import { useEffect, useRef } from 'react'

import { AppLoading } from '@/components/AppLoading'

import { useNavigate } from 'react-router'
import { useAuth } from '../../context/AuthContext'

export const WithAuth = <T extends object>(
  WrappedComponent: React.ComponentType<T>,
) => {
  const NewComponent = (props: T) => {
    const { isLogged, isLoading, user } = useAuth()
    const isRedirected = useRef(false)
    const navigate = useNavigate()

    const redirectToLogin = () => {
      if (isRedirected.current) return
      isRedirected.current = true

      navigate(`/auth/login-sso?returnUrl=${window.location.href}`)
    }

    useEffect(() => {
      if (!isLogged && !isLoading)
        redirectToLogin()
    }, [isLogged, isLoading])

    const buildDate = user?.buildDate

    useEffect(() => {
      if (isLogged && buildDate) {
        // vynucení reload stránky, pokud se změní verze API
        const lastBuildDate = window.localStorage.getItem('api-build-date')
        window.localStorage.setItem('api-build-date', buildDate)

        if (buildDate !== lastBuildDate) window.location.reload()
      }
    }, [buildDate])

    return (
      <>
        {!isLogged && <AppLoading />}
        {isLogged && <WrappedComponent {...props} />}
      </>
    )
  }

  return NewComponent
}
